import React from "react";

import { TextAreaContainer } from "./styles";

const TextArea = ({
  onChange = () => {},
  value,
  placeholder,
  disableNewLine = false,
}) => {
  return (
    <TextAreaContainer
      onInput={(e) => {
        if (disableNewLine && e.nativeEvent.inputType === "insertLineBreak") {
          return;
        }
        onChange(e);
      }}
      value={value}
      placeholder={placeholder}
      rows="5"
    />
  );
};

export default TextArea;
